import {RouterModule, Routes} from "@angular/router";

import {CustomerComponent} from "./pages/customer/customer.component";
import {InvoiceComponent} from "./pages/invoice/invoice.component";
import {QuoteComponent} from "./pages/quote/quote.component";
import {PackComponent} from "./pages/pack/pack.component";
import {PostitsComponent} from "./pages/postits/postits.component";
//import { BikeComponent } from './pages/bike/bike.component';
import {NotPaidComponent} from "./pages/notPaid/notPaid.component";
import {MarketingComponent} from "./pages/marketing/marketing.component";
import {StatisticComponent} from "./pages/statistic/statistic.component";
import {BikesComponent} from "./pages/bikes/bikes.component";
import {OneBikeComponent} from "./pages/oneBike/oneBike.component";
import {TasksComponent} from "./pages/tasks/tasks.component";
import {HomeComponent} from "./home.component";
import {ExportComponent} from './pages';

const routes: Routes = [
    {
        path: "", component: HomeComponent, children: [
            {path: "", redirectTo: "postit", pathMatch: "full"},

            {path: "customer/:privateId", component: CustomerComponent},
            {path: "customer/new/:data", component: CustomerComponent},

            {path: "postit", component: PostitsComponent},
            {path: "postit/:archive", component: PostitsComponent},

            {path: "invoice/:customerPrivateId", component: InvoiceComponent},
            {path: "invoice/:customerPrivateId/:invoicePrivateId", component: InvoiceComponent},
            {path: "invoice/:customerPrivateId/:invoicePrivateId/:duplicate", component: InvoiceComponent},

            {path: "quote/:customerPrivateId", component: QuoteComponent},
            {path: "quote/:customerPrivateId/:quotePrivateId", component: QuoteComponent},
            {path: "quote/:customerPrivateId/:iquotePrivateId/:duplicate", component: QuoteComponent},

            {path: "pack", component: PackComponent},

            {path: "bike/:id", component: OneBikeComponent},

            {path: "tasks", component: TasksComponent},

            {path: "notPaid", component: NotPaidComponent},

            {path: "bikes", component: BikesComponent},

            {path: "export", component: ExportComponent},

            {path: "marketing", component: MarketingComponent},
            {path: "marketing/:old", component: MarketingComponent},

            {path: "statistic", component: StatisticComponent},
            {path: "**", redirectTo: "postit", pathMatch: "full"}
        ]
    }]

export const homeRouting = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/home.routing.ts